import { getPlayersWithTourAndBioV2 } from '@/api/endpoints';
import { PlayerForSaveDto } from '@/api/models';
import { PlayerDB } from '@/db/repositories';
import { setDBUpdatedNow, getDBUpdatedOn } from '@/db/helpers/dbMetadata';
import { onlineStatus } from '@/utils';
import { Contract } from '@/api/models/PlayerContractHistory';

// This function syncs the player list data from the backend
export const syncPlayerData = async (): Promise<void> => {
  const isOnline = onlineStatus.get();
  if (!isOnline) return;

  // No stale or forceUpdate check, always fetch players delta data from the API if online

  try {
    const modifiedAfter = await getDBUpdatedOn('getPlayersWithTourAndBioV2');
    const players = await getPlayersWithTourAndBioV2(modifiedAfter);

    await PlayerDB.applyDelta(players);
    await setDBUpdatedNow('getPlayersWithTourAndBioV2');
  } catch (error) {
    console.error('Failed to fetch getPlayersWithTourAndBioV2 from API:', error);
    // TODO: Save error to ErrorLogRepo
  }
};

interface IQueryPlayersWithOffsetProps {
  nameQuery: string | null;
  selectedAccount: string | null;
  myPlayerIds: number[] | null;
  offset: number;
  pageSize: number;
}

// This function interacts with the local player list data
export const queryPlayersWithOffset = async ({ nameQuery, selectedAccount, myPlayerIds, offset, pageSize }: IQueryPlayersWithOffsetProps): Promise<{ players: PlayerForSaveDto[]; total: number }> => {
  let players, total; // declare variables and assign them

  if (nameQuery || selectedAccount || myPlayerIds) {
    ({ players, total } = await PlayerDB.queryPaginated(nameQuery, selectedAccount, myPlayerIds, offset, pageSize));
  } else {
    ({ players, total } = await PlayerDB.listPaginated(offset, pageSize));
  }

  return { players, total };
};

export const updatePlayerContract = async ({ playerId, contract }: { playerId: number; contract: Pick<Contract, 'startDate' | 'endDate' | 'status' | 'items'> }): Promise<void> => {
  try {
    // put = add or replace by primary key
    await PlayerDB.updatePlayerContract(playerId, contract);
  } catch (error) {
    console.error(`Failed to update player ${playerId} in DB:`, error);
    // TODO: Save error to ErrorLogRepo
    throw error;
  }
};
